import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { SessionExpiredService } from '../services/session-expired-service';
import { UserRolesService } from '../services/user-roles.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionStorageService } from '../core/services/session-storage.service';

@Component({
    selector: 'app-session-timeout',
    templateUrl: './session-timeout.component.html',
    styleUrls: ['./session-timeout.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SessionTimeoutComponent implements OnInit {

  constructor(private _sessionExpiredService: SessionExpiredService,
    public userRoleService: UserRolesService,
    public router: Router,
    private modalService: NgbModal,
    private sessionStorage: SessionStorageService) { }

  ngOnInit() {
    this.userRoleService.setLeftNavigationProperty();
    //this.logOut();
  }

  //logOut() {
  //  this._sessionExpiredService.signOutSession().subscribe((data: any) => {
  //    this.modalService.dismissAll();
  //    this.sessionStorage.removeItem('HighestRoleId');
  //  },
  //    err => {
  //    }
  //  );
  //};

}
